/*
 * @Author: your name
 * @Date: 2021-08-20 15:26:50
 * @LastEditTime: 2022-04-08 09:46:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-element-ui-admin\src\utils\index.js
 */

import Storage from "good-storage";

/**
 * @description 获取表格高度
 * @param  type  {String}  default: 'table'  table 表格高度，content 包含页码的表格高度， all 两者皆获取
 */
export const getTableHeight = type => {
  let $navbar = document.getElementById("navbar") || {
    offsetHeight: 48
  };
  let $tagsview = document.getElementById("tags-view") || {
    offsetHeight: 41
  }; //用offsetHeight不用clientHeight是因为后者的高度不包括border
  // console.log('navbar', $navbar.offsetHeight);
  // console.log('tagsview', $tagsview.offsetHeight);
  let $opers = document.getElementsByClassName("oper-container");
  let $operHeight = $opers && $opers.length ? $opers[0].offsetHeight || 40 : 40;
  let $vPages = document.getElementsByClassName("pagination-container");

  let contentHeightFull =
    getViewPortHeight() -
    ($navbar.offsetHeight + $tagsview.offsetHeight + $operHeight);
  let contentHeight = contentHeightFull - 2;
  if (type === "content") {
    return contentHeight;
  }
  let $paginationHeight =
    $vPages && $vPages.length ? ($vPages[0].offsetHeight || 33) + 7 : 40;
  let tableHeight = contentHeightFull - $paginationHeight;
  // console.log('operContainer', $operHeight, tableHeight);
  return type === "all" ? {
      tableHeight,
      contentHeight
    } :
    tableHeight;
};

/**
 * @description 获取可视区高度
 * @returns
 */
export const getViewPortHeight = () => {
  return document.documentElement.clientHeight || document.body.clientHeight;
};

/**
 * @description 获取可视区宽度
 * @returns
 */
export const getViewPortWidth = () => {
  return document.documentElement.clientWidth || document.body.clientWidth;
};

/**
 * 获取内容区域宽度
 * @returns
 */
export const getContentViewWidth = () => {
  const hideSidebar = Storage.get("HideSidebar");
  const miniSidebar = Storage.get("MiniSidebar");
  // 6 是两边的内边距
  if (hideSidebar === 1) {
    return getViewPortWidth() - (6 + 6);
  } else if (hideSidebar === 0 && miniSidebar === 1) {
    return getViewPortWidth() - (64 + 6 + 6);
  } else if (hideSidebar === 0 && miniSidebar === 0) {
    return getViewPortWidth() - (230 + 6 + 6);
  }
};

/**
 * 获取内容区域高度
 * @returns
 */
export const getContentViewHeight = () => {
  let bodyTop = document.getElementsByClassName("body-top");
  let navBar = document.getElementsByClassName("nav-bar");
  if (bodyTop.length === 0) {
    bodyTop = 50;
  } else {
    bodyTop = bodyTop[0].clientHeight;
  }

  if (navBar.length === 0) {
    navBar = 38;
  } else {
    navBar = navBar[0].clientHeight;
  }
  // 6是顶部内边距
  return getViewPortHeight() - (bodyTop + navBar + 6);
};

/**
 * 函数防抖
 * @param {*} func 目标函数
 * @param {*} wait 延迟执行毫秒数
 * @param {*} immediate true - 立即执行， false - 延迟执行
 * @returns 
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function(...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

// /**
//  * @description debounce
//  * @param {*} func 函数
//  * @param {*} wait 等待时间
//  * @param {*} immediate 是否首次立刻执行，默认否
//  */
// export const debounce = (func, wait, immediate) => {
//   var timeout, result;
//   var debounced = function () {
//     var context = this;
//     var args = arguments;
//     if (timeout) clearTimeout(timeout);
//     if (immediate) {
//       // 如果已经执行过，不再执行
//       var callNow = !timeout;
//       timeout = setTimeout(function () {
//         timeout = null;
//       }, wait);
//       if (callNow) result = func.apply(context, args);
//     } else {
//       timeout = setTimeout(function () {
//         func.apply(context, args);
//       }, wait);
//     }
//     return result;
//   };
//   // 取消执行函数
//   debounced.cancel = function () {
//     clearTimeout(timeout);
//     timeout = null;
//   };
//   return debounced;
// };